module.exports = __webpack_public_path__ + "img/LUB00008.5fa8783a.png";